import { render, staticRenderFns } from "./futureList.vue?vue&type=template&id=402d8972&scoped=true"
import script from "./futureList.vue?vue&type=script&lang=js"
export * from "./futureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402d8972",
  null
  
)

export default component.exports